module.exports = __webpack_public_path__ + "54a94f7bcc21d6265fe71cdc94843043.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Review/5.jpg
// module id = 436
// module chunks = 0 2